import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../../components/DynamicSkeleton"

const columnConfig = {
  "Vehicle ID": { content: <Skeleton height="20px" width="80px" />, center: true },
  "Registration Number": {
    content: <Skeleton height="20px" width="150px" />,
    center: true,
  },
  "Fleet Client": {
    content: <Skeleton height="30px" width="140px" />,
    center: true,
  },
  Model: { content: <Skeleton height="20px" width="120px" />, center: true },
  "Vehicle Type": {
    content: <Skeleton height="20px" width="110px" />,
    center: true,
  },
  Status: { content: <Skeleton height="20px" width="90px" />, center: true },
  "Verification Status": {
    content: <Skeleton height="20px" width="120px" />,
    center: true,
  },
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const FleetVehicleManagementSkeleton = ({ infiniteScroll, rows = 6 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default FleetVehicleManagementSkeleton
